import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { useProjectStore } from "@/zapi-frontend/stores/project";
import { OverviewHeader } from "./OverviewHeader";
import { OpportunityFrameBlock } from "./OpportunityFrameBlock";
import { SuccessCriteriaBlock } from "./SuccessCriteriaBlock";
import { KeyInsightsBlock } from "./KeyInsightsBlock";
import { NextStepsBlock } from "./NextStepsBlock";
import { SectionCard } from "./SectionCard";

export function DecisionBriefOverview() {
  const { t } = useTranslation("projectHome");
  const { selectedProject, syncOverviewIfNeeded, syncingOverviewProjectId } = useProjectStore();
  if (!selectedProject) return null;

  const overview = selectedProject.overview;
  const nextSteps = selectedProject.nextSteps || [];
  const isSyncingOverview = syncingOverviewProjectId === selectedProject.id;

  const handleRefresh = async () => {
    if (isSyncingOverview) return;
    try {
      await syncOverviewIfNeeded(selectedProject.id);
    } catch {
      toast.error(t("overview.failedToRefresh"));
    }
  };

  return (
    <div className="w-full h-full flex items-start justify-center overflow-y-auto bg-projectPage">
      <div className="flex flex-col w-full pb-2 gap-2">
        <OverviewHeader project={selectedProject} onRefresh={handleRefresh} isRefreshing={isSyncingOverview} />

        {overview ? (
          <>
            <OpportunityFrameBlock overview={overview} />
            <SuccessCriteriaBlock overview={overview} />
            <KeyInsightsBlock overview={overview} />
          </>
        ) : (
          <SectionCard label={t("overview.decisionBrief")}>
            <FigmaTypography variant="body-2" color="zinc500">
              {t("overview.decisionBriefEmpty")}
            </FigmaTypography>
          </SectionCard>
        )}

        <NextStepsBlock nextSteps={nextSteps} />
      </div>
    </div>
  );
}
